import { TextInput, FormError, Button } from "@components";

export default function NamePage({
  isEditMode,
  control,
  errors,
  loading,
  onBack,
  onSubmit,
}) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      className="p-5 space-y-4"
    >
      <TextInput
        name="name"
        control={control}
        placeholder="Give your template a name"
        required
        errors={errors.name}
        displayName="Template name"
        maxLength={50}
      />
      <FormError name="name" errors={errors} />
      <div className="flex gap-2">
        <Button
          type="button"
          className="shrink-0 rounded-lg"
          onClick={onBack}
          disabled={loading}
        >
          {isEditMode ? "Back" : "Cancel"}
        </Button>
        <Button
          type="submit"
          color="primary"
          className="shrink-0 grow rounded-lg"
          submitting={loading}
        >
          {isEditMode ? "Save" : "Continue"}
        </Button>
      </div>
    </form>
  );
}
